<template>
    <text-banner
        v-if="showBanner"
        title="SWITCHING ORGANISATIONS"
        :text="text"
        icon="fas fa-exchange-alt"
        @close="hideBanner"
    />
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import TextBanner from '../components/TextBanner';
import { ParticipantModel } from '../models';

export default {
    components: {
        TextBanner,
    },
    mounted() {
        ParticipantModel.getCurrentParticipant('org_backend_switch_banner', true).then(participant => {
            if (participant) {
                const { switchOrganizationsBannerViewed, participantOrganizations } = participant;
                if (!switchOrganizationsBannerViewed) {
                    ParticipantModel.patch(participant.id, {
                        params: {
                            'response-group': 'current_participant',
                        },
                        body: {
                            switchOrganizationsBannerViewed: true,
                        },
                    }).catch(() => {});
                    const organizations = participantOrganizations.filter(po => po.role === 'Admin');
                    if (organizations.length > 1) {
                        this.setShowBanner(true);
                    }
                }
            }
            if (!this.showBanner) {
                this.setShowBanner(false);
            }
        });
    },
    beforeDestroy() {
        this.setShowBanner(false);
    },
    computed: {
        ...mapState('organization', ['showBanner']),
        ...mapGetters('organization', ['selectedOrganization']),
        text() {
            const message =
                'Du befindest dich gerade bei der Organisation "ORGANIZATION_NAME". Im Menü kannst du deine Organisation jederzeit wechseln';
            return this.$t(message).replace('ORGANIZATION_NAME', this.selectedOrganization.name);
        },
    },
    methods: {
        ...mapMutations('organization', ['setShowBanner']),
        hideBanner() {
            this.setShowBanner(false);
        },
    },
};
</script>
